import { FC, useEffect, useState } from 'react'
import { isNotEmpty } from '../../../../../../_metronic/helpers'
import { useListView } from '../core/ListViewProvider'
import { useQueryResponse } from '../core/QueryResponseProvider'
import axios from 'axios'
import { toast } from 'react-toastify'
import { POST_BLOG_CATEGORY, BLOG_CATEGORY_DATA } from '../../../../../modules/auth/core/_requests'

type Props = {
  isUserLoading: boolean
  user: any
}

interface Option {
  id: string;
  name: string;
}

const UserEditModalForm: FC<Props> = ({ user, isUserLoading }) => {
  const { setItemIdForUpdate } = useListView()
  const { refetch } = useQueryResponse()

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
  }

  const [name, setName] = useState(user.name ? user.name : '');
  const [parentId, setParentId] = useState(user.parent_id ? user.parent_id : null);
  const [options, setOptions] = useState<Option[]>([]);

  useEffect(() => {
    axios.get(BLOG_CATEGORY_DATA)
      .then(response => {
        setOptions(response.data);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      formData.append('name', `${name}`);
      if (parentId) {
        formData.append('parentId', `${parentId}`);
      }
      if (isNotEmpty(user.id)) {
        formData.append('id', `${user.id}`);
      }

      const response = await axios.post(`${POST_BLOG_CATEGORY}`, formData);

      if (response.data.status == 1) {
        toast.success(response.data.message);
        cancel(true)
      }
      else {
        toast.error(response.data.message);
      }
    } catch (ex) {
      console.error(ex)
    }
  };

  return (
    <>
        <form onSubmit={handleSubmit} className="d-flex flex-column gap-6">
          <div className="form-group">
            <label className="form-label required fw-semibold fs-6 mb-2">Name</label>
            <input 
              type="text" 
              className="form-control form-control-solid" 
              value={name} 
              onChange={event => setName(event.target.value)}
              placeholder="Enter category name"
            />
          </div>

          <div className="form-group">
            <label className="form-label fw-semibold fs-6 mb-2">Parent Category</label>
            <select 
              className="form-select form-select-solid" 
              value={parentId === null ? '' : parentId} 
              onChange={event => setParentId(event.target.value)}
            >
              <option value="">Select parent category (optional)</option>
              {options && options.map(option => (
                <option key={option.id} value={option.id}>{option.name}</option>
              ))}
            </select>
          </div>

          <div className="d-flex justify-content-end gap-3">
            <button 
              type="button" 
              className="btn btn-light" 
              onClick={() => cancel()}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={isUserLoading}
            >
              {isUserLoading ? (
                <span className="indicator-label">Please wait...</span>
              ) : (
                <span className="indicator-label">Save Changes</span>
              )}
            </button>
          </div>
        </form>
      </>
  )
}

export { UserEditModalForm }
